<template>
  <div class="home-container">
    <!-- 地图作为最底层背景 -->
    <div class="map-layer">
      <div id="home-map-container"></div>
    </div>

    <!-- 内容层：在地图上层放置信息面板 -->
    <div class="content-layer">
      <!-- 左侧信息面板区 -->
      <div class="left-panel-area">
        <!-- 车辆状况 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">关键运营指标</h3>
          </div>
          <div class="panel-body">
            <div class="vehicle-status-content">
              <div class="vehicle-total">
                <div class="vehicle-label">监管装备/车辆总数</div>
                <div class="vehicle-number">{{ vehicleTotalCount }}<span class="vehicle-unit">辆</span></div>
              </div>
              <div class="vehicle-online">
                <div class="vehicle-label">在线装备/车辆</div>
                <div class="vehicle-number online">{{ vehicleOnlineCount }}<span class="vehicle-unit">辆</span></div>
              </div>
            </div>
            <!-- 运营指标（模拟数据） -->
            <div class="vehicle-status-content operation-metrics">
              <div class="vehicle-total">
                <div class="vehicle-label">已审核线路数</div>
                <div class="vehicle-number">{{ auditedRouteCount }}<span class="vehicle-unit">条</span></div>
              </div>
              <div class="vehicle-online">
                <div class="vehicle-label">已审核线路里程</div>
                <div class="vehicle-number">{{ auditedRouteMileage }}<span class="vehicle-unit">公里</span></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 企业车辆统计 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">企业车辆统计</h3>
          </div>
          <div class="panel-body">
            <div ref="deptVehicleChart" class="dept-chart-container"></div>
          </div>
        </div>

        <!-- 路权审批指标 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">路权审批指标</h3>
          </div>
          <div class="panel-body">
            <div class="approval-chart-container">
              <!-- 左侧：通过率饼图 -->
              <div ref="approvalChart" class="approval-pie"></div>
              <!-- 右侧：审核项列表（带外边框） -->
              <div class="approval-legend">
                <div
                    v-for="item in approvalDisplay"
                    :key="item.name"
                    :class="['approval-item', item.cls]"
                >
                  <span class="approval-dot"></span>
                  <span class="approval-name">{{ item.name }}</span>
                  <span class="approval-value">{{ item.value }}条</span>
                  <span class="approval-percent">{{ item.percent }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 企业概括 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">企业概括</h3>
          </div>
          <div class="panel-body">
            <div class="enterprise-table-container">
              <table class="enterprise-table">
                <thead>
                <tr>
                  <th class="col-index">序号</th>
                  <th class="col-company">企业名称</th>
                  <th class="text-right">线路(条)</th>
                  <th class="text-right">接入车辆(辆)</th>
                </tr>
                </thead>
                <tbody v-if="companyList.length > 0">
                <tr
                    v-for="(item, index) in displayCompanyList"
                    :key="index"
                >
                  <td class="col-index">{{ companyList.length < 7 ? index + 1 : currentIndex + index + 1 }}</td>
                  <td class="col-company">
                    <div class="marquee-wrap">
                      <span class="marquee-text">{{ item.companyName || '未命名企业' }}</span>
                    </div>
                  </td>
                  <td class="text-right">{{ item.routeNum }}</td>
                  <td class="text-right">{{ item.vehicleNum }}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="4" class="empty-tip">暂无数据</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧信息面板区 -->
      <div class="right-panel-area">
        <!-- 运行里程信息 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">运行里程信息</h3>
          </div>
          <div class="panel-body">
            <!-- 上方：累计运行里程 + 今日运行里程 -->
            <div class="mileage-stats">
              <div class="mileage-card">
                <div class="mileage-label">累计运行里程</div>
                <div class="mileage-number">{{ totalMileage }}<span class="mileage-unit">km</span></div>
              </div>
              <div class="mileage-card today">
                <div class="mileage-label">今日运行里程</div>
                <div class="mileage-number">{{ todayMileage }}<span class="mileage-unit">km</span></div>
              </div>
            </div>
            <!-- 下方：近7天每日运行里程柱状图 -->
            <div ref="mileageChart" class="mileage-chart-container"></div>
          </div>
        </div>

        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">运营线路动态评价</h3>
          </div>
          <div class="panel-body">
            <!-- 面板内容后面再设计 -->
          </div>
        </div>

        <!-- 事件概括 -->
        <div class="info-panel">
          <div class="panel-header">
            <h3 class="panel-title">事件概括</h3>
          </div>
          <div class="panel-body">
            <div class="event-summary">
              <div class="event-circles">
                <div class="event-circle" v-for="item in alarmLevelList" :key="item.level">
                  <div :class="['circle', item.cls]">{{ item.total }}</div>
                  <div class="circle-label">{{ item.label }}</div>
                </div>
              </div>
              <div class="event-table-container">
                <table class="event-table">
                  <thead>
                  <tr>
                    <th class="col-company">企业</th>
                    <th>警告</th>
                    <th>轻微</th>
                    <th>中度</th>
                    <th>严重</th>
                  </tr>
                  </thead>
                  <tbody v-if="companyAlarmList.length > 0">
                  <tr v-for="(item, index) in companyAlarmList" :key="index">
                    <td class="col-company">
                      <div class="marquee-wrap">
                        <span class="marquee-text">{{ item.deptName || '未命名企业' }}</span>
                      </div>
                    </td>
                    <td>{{ item.level1 }}</td>
                    <td>{{ item.level2 }}</td>
                    <td>{{ item.level3 }}</td>
                    <td>{{ item.level4 }}</td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr>
                    <td colspan="5" class="empty-tip">暂无数据</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { shallowRef, ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'
import AMapLoader from '@amap/amap-jsapi-loader'
import * as echarts from 'echarts'
import { getStopList } from '@/api/roads/stop.js'
import { getRoutePathList } from '@/api/task/route.js'
import { companyApplicationInfo, vehicleCount, vehicleCountByDept, taskStatusCount, alarmLevelCount, companyAlarmLevelInfoCount } from '@/api/matedata'
import { countVehicleOnlineStatus } from '@/api/realtime/vehicleStatus'

// 高德地图安全密钥（必须在 AMapLoader.load 之前设置）
window._AMapSecurityConfig = {
  securityJsCode: 'cd0893188bd79a43d8e4539aec2e2b2a',
}

const map = shallowRef(null)
let AMap = null
let stopMarkers = []
let routePolylines = []

// 车辆状况数据
const vehicleTotalCount = ref(0)
const vehicleOnlineCount = ref(0)
let onlineStatusTimer = null

// 运营指标（模拟数据，后续接入真实接口时替换）
const auditedRouteCount = ref(0)
const auditedRouteMileage = ref(0)

// 企业概括数据（参考 dashboard/matedata.vue 的企业概括表格）
const companyList = ref([])
const currentIndex = ref(0)
let pollTimer = null

// 获取车辆总数
const loadVehicleTotalCount = async () => {
  try {
    const res = await vehicleCount()
    const data = res?.data
    vehicleTotalCount.value =
        data !== null && data !== undefined && typeof data === 'object'
            ? (data.value ?? 0)
            : (data ?? 0)
  } catch (error) {
    console.error('获取车辆总数失败:', error)
  }
}

// 获取在线车辆数
const fetchVehicleOnlineCount = async () => {
  try {
    const res = await countVehicleOnlineStatus()
    if (res && res.code === 200) {
      vehicleOnlineCount.value = res.data !== undefined && res.data !== null ? res.data : 0
    }
  } catch (error) {
    console.error('获取在线车辆数失败:', error)
  }
}

// 启动在线车辆数定时刷新（每30秒）
const startOnlineStatusRefresh = () => {
  if (onlineStatusTimer) {
    clearInterval(onlineStatusTimer)
  }
  onlineStatusTimer = setInterval(() => {
    fetchVehicleOnlineCount()
  }, 30000)
}

const stopOnlineStatusRefresh = () => {
  if (onlineStatusTimer) {
    clearInterval(onlineStatusTimer)
    onlineStatusTimer = null
  }
}

// 显示的企业列表：超过7条时轮播，每次显示3条
const displayCompanyList = computed(() => {
  if (companyList.value.length < 7) {
    return companyList.value
  }
  const len = companyList.value.length
  const start = currentIndex.value % len
  const end = start + 3
  if (end <= len) {
    return companyList.value.slice(start, end)
  }
  return [...companyList.value.slice(start), ...companyList.value.slice(0, end - len)]
})

// 启动企业列表轮播
const startPolling = () => {
  if (pollTimer) clearInterval(pollTimer)
  pollTimer = setInterval(() => {
    if (companyList.value.length >= 7) {
      currentIndex.value = (currentIndex.value + 3) % companyList.value.length
    }
  }, 2000)
}

const stopPolling = () => {
  if (pollTimer) {
    clearInterval(pollTimer)
    pollTimer = null
  }
}

// 加载企业概括数据
const loadCompanyList = async () => {
  try {
    const res = await companyApplicationInfo()
    companyList.value = Array.isArray(res.data) ? res.data : []
    if (companyList.value.length >= 7) {
      startPolling()
    }
  } catch (error) {
    console.error('获取企业概括信息失败:', error)
    companyList.value = []
  }
}

// 企业车辆统计饼图
const deptVehicleChart = ref(null)
let deptVehicleChartInstance = null
const deptVehicleData = ref([])

// 加载企业车辆统计数据（接口返回 [{ deptName, total }]）
const loadDeptVehicleData = async () => {
  try {
    const res = await vehicleCountByDept()
    const list = Array.isArray(res?.data) ? res.data : []
    deptVehicleData.value = list.map((item) => ({
      name: item.deptName || '未命名企业',
      value: parseInt(item.total) || 0,
    }))
  } catch (error) {
    console.error('获取企业车辆统计失败:', error)
    deptVehicleData.value = []
  }
}

// 初始化企业车辆统计饼图（参考 dashboard/matedata.vue 的车辆用途饼图）
const initDeptVehicleChart = () => {
  if (!deptVehicleChart.value) return
  if (deptVehicleChartInstance) {
    deptVehicleChartInstance.dispose()
    deptVehicleChartInstance = null
  }
  deptVehicleChartInstance = echarts.init(deptVehicleChart.value)

  const chartData = deptVehicleData.value
  const totalVehicles = chartData.reduce((sum, item) => sum + item.value, 0)

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: { color: '#fff' },
    },
    legend: { show: false },
    color: ['#00bcd4', '#03a9f4', '#2196f3', '#9c27b0', '#ff9800', '#4caf50', '#e91e63'],
    series: [
      {
        name: '企业车辆统计',
        type: 'pie',
        radius: ['18%', '50%'],
        center: ['50%', '50%'],
        // 小占比扇区也保留最小角度，避免过细难以辨认
        minAngle: 8,
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 2,
          borderColor: '#0a1929',
          borderWidth: 0.8,
        },
        // 数据标注直接显示在对应扇区外侧
        label: {
          show: true,
          position: 'outside',
          color: '#fff',
          fontSize: 11,
          fontWeight: 500,
          formatter: (params) => `${params.name} ${params.value}辆\n${params.percent}%`,
        },
        labelLine: {
          show: true,
          length: 4,
          length2: 6,
          lineStyle: { color: 'rgba(255,255,255,0.6)' },
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 13,
            fontWeight: 'bold',
            color: '#fff',
          },
        },
        data: chartData,
      },
    ],
    // 中心空状态提示
    graphic: totalVehicles === 0
        ? {
          type: 'text',
          left: 'center',
          top: 'middle',
          style: { text: '暂无数据', fill: '#999', fontSize: 13 },
        }
        : null,
  }

  deptVehicleChartInstance.setOption(option)
}

// 数据变化后刷新饼图
watch(deptVehicleData, () => {
  nextTick(() => initDeptVehicleChart())
})

// 路权审批指标饼图
const approvalChart = ref(null)
let approvalChartInstance = null
// 审核数据：已审核、待审核、审核驳回（初始为0，通过 taskStatusCount 接口加载）
const approvalData = ref([
  { name: '审核通过', value: 0, cls: 'pass', color: '#4caf50' },
  { name: '待审核', value: 0, cls: 'pending', color: '#ff9800' },
  { name: '审核驳回', value: 0, cls: 'reject', color: '#f44336' },
])

// 加载路权审批数据
const loadApprovalData = async () => {
  try {
    const res = await taskStatusCount()
    if (res && res.code === 200 && res.data) {
      approvalData.value[0].value = Number(res.data.approveTotal) || 0
      approvalData.value[1].value = Number(res.data.reviewingTotal) || 0
      approvalData.value[2].value = Number(res.data.rejectTotal) || 0
    }
  } catch (error) {
    console.error('获取路权审批数据失败:', error)
  }
}

// 右侧列表显示数据（带百分比，用于模板对齐渲染）
const approvalDisplay = computed(() => {
  const total = approvalData.value.reduce((sum, item) => sum + item.value, 0)
  return approvalData.value.map((item) => ({
    name: item.name,
    value: item.value,
    cls: item.cls,
    percent: total > 0 ? ((item.value / total) * 100).toFixed(1) : '0.0',
  }))
})

// 初始化路权审批通过率饼图（只展示通过率，中心显示百分比）
const initApprovalChart = () => {
  if (!approvalChart.value) return
  if (approvalChartInstance) {
    approvalChartInstance.dispose()
    approvalChartInstance = null
  }
  approvalChartInstance = echarts.init(approvalChart.value)

  const list = approvalData.value
  const total = list.reduce((sum, item) => sum + item.value, 0)
  const passCount = list[0]?.value || 0
  const passRate = total > 0 ? (passCount / total * 100).toFixed(1) : '0.0'

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: { color: '#fff' },
    },
    series: [
      {
        name: '路权审批通过率',
        type: 'pie',
        radius: ['55%', '78%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 2,
          borderColor: '#0a1929',
          borderWidth: 0.8,
        },
        // 中心显示通过率百分比
        label: {
          show: true,
          position: 'center',
          formatter: () => `{title|通过率}\n{rate|${passRate}%}`,
          rich: {
            title: {
              fontSize: 11,
              color: '#fff',
              lineHeight: 18,
            },
            rate: {
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4caf50',
              lineHeight: 26,
            },
          },
        },
        labelLine: { show: false },
        emphasis: {
          label: { show: true },
        },
        // 只有两段：通过 / 其余
        data: [
          { name: '审核通过', value: passCount, itemStyle: { color: '#4caf50' } },
          { name: '其余', value: total - passCount, itemStyle: { color: 'rgba(255,255,255,0.12)' } },
        ],
      },
    ],
    graphic: total === 0
        ? {
          type: 'text',
          left: 'center',
          top: 'middle',
          style: { text: '暂无数据', fill: '#999', fontSize: 13 },
        }
        : null,
  }

  approvalChartInstance.setOption(option)
}

// 数据变化后刷新饼图
watch(approvalData, () => {
  nextTick(() => initApprovalChart())
}, { deep: true })

// 运行里程信息
const mileageChart = ref(null)
let mileageChartInstance = null
// 模拟数据：累计运行里程、今日运行里程
const totalMileage = ref(0)
const todayMileage = ref(0)
// 近7天每日运行里程（模拟数据）
const mileageWeekData = ref([
  { date: '09-23', value: 0 },
  { date: '09-24', value: 0 },
  { date: '09-25', value: 0 },
  { date: '09-26', value: 0 },
  { date: '09-27', value: 0 },
  { date: '09-28', value: 0 },
  { date: '09-29', value: 0 },
])

// 初始化近7天运行里程柱状图
const initMileageChart = () => {
  if (!mileageChart.value) return
  if (mileageChartInstance) {
    mileageChartInstance.dispose()
    mileageChartInstance = null
  }
  mileageChartInstance = echarts.init(mileageChart.value)

  const dates = mileageWeekData.value.map((item) => item.date)
  const values = mileageWeekData.value.map((item) => item.value)

  const option = {
    tooltip: {
      trigger: 'axis',
      formatter: (params) => `${params[0].name}<br/>运行里程: ${params[0].value} km`,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: { color: '#fff' },
    },
    grid: { left: 35, right: 10, top: 20, bottom: 25 },
    xAxis: {
      type: 'category',
      data: dates,
      axisLine: { lineStyle: { color: 'rgba(255,255,255,0.4)' } },
      axisLabel: { color: '#fff', fontSize: 10 },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      axisLine: { show: false },
      axisLabel: { color: '#fff', fontSize: 10 },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
    },
    series: [
      {
        name: '每日运行里程',
        type: 'bar',
        barWidth: '50%',
        itemStyle: {
          borderRadius: [3, 3, 0, 0],
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: '#5cacee' },
              { offset: 1, color: '#03a9f4' },
            ],
          },
        },
        label: { show: false },
        data: values,
      },
    ],
  }

  mileageChartInstance.setOption(option)
}

// 事件概括 - 告警等级统计
// level 映射：1.警告 2.轻微 3.中度 4.严重
const alarmLevelList = ref([
  { level: 1, label: '警告', cls: 'blue', total: 0 },
  { level: 2, label: '轻微', cls: 'yellow', total: 0 },
  { level: 3, label: '中度', cls: 'orange', total: 0 },
  { level: 4, label: '严重', cls: 'red', total: 0 },
])

// 加载告警等级统计数据（接口返回 [{level, total}]）
const loadAlarmLevelCount = async () => {
  try {
    const res = await alarmLevelCount()
    if (res && res.code === 200 && Array.isArray(res.data)) {
      res.data.forEach((item) => {
        const target = alarmLevelList.value.find((it) => it.level === item.level)
        if (target) {
          target.total = Number(item.total) || 0
        }
      })
    }
  } catch (error) {
    console.error('获取告警等级统计失败:', error)
  }
}

// 企业告警等级信息统计（接口返回 [{deptName, level1, level2, level3, level4}]）
const companyAlarmList = ref([])

const loadCompanyAlarmLevelInfo = async () => {
  try {
    const res = await companyAlarmLevelInfoCount()
    if (res && res.code === 200 && Array.isArray(res.data)) {
      companyAlarmList.value = res.data.map((item) => ({
        deptName: item.deptName || '未命名企业',
        level1: Number(item.level1) || 0,
        level2: Number(item.level2) || 0,
        level3: Number(item.level3) || 0,
        level4: Number(item.level4) || 0,
      }))
    }
  } catch (error) {
    console.error('获取企业告警等级信息失败:', error)
    companyAlarmList.value = []
  }
}

// 解析经纬度（支持数组 [lng, lat] 或字符串 "lng,lat"）
const parseCoord = (coord) => {
  if (!coord) return null
  if (Array.isArray(coord)) {
    if (coord.length !== 2 || isNaN(coord[0]) || isNaN(coord[1])) return null
    return coord
  }
  if (typeof coord === 'string') {
    const parts = coord.split(',').map((s) => parseFloat(s.trim()))
    if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return null
    return parts
  }
  return null
}

// 绘制所有站点标记
const drawStops = (stops) => {
  if (!map.value || !AMap) return
  stopMarkers.forEach((m) => {
    try { map.value.remove(m) } catch (e) { /* ignore */ }
  })
  stopMarkers = []

  stops.forEach((stop) => {
    const coord = parseCoord(stop.gcj02Coordinates)
    if (!coord) return

    const marker = new AMap.Marker({
      position: coord,
      content: `<div style="width:12px;height:12px;border-radius:50%;background:#00bcd4;border:2px solid #fff;box-shadow:0 0 6px rgba(0,188,212,0.8);"></div>`,
      anchor: 'bottom-center',
      zIndex: 120,
    })
    marker.setMap(map.value)
    stopMarkers.push(marker)
  })
}

// 绘制所有路线
const drawRoutes = (routes) => {
  if (!map.value || !AMap) return
  routePolylines.forEach((p) => {
    try { map.value.remove(p) } catch (e) { /* ignore */ }
  })
  routePolylines = []

  routes.forEach((path) => {
    if (!Array.isArray(path) || path.length < 2) return
    const polyline = new AMap.Polyline({
      path,
      strokeColor: '#5CACEE',
      strokeOpacity: 0.9,
      strokeWeight: 4,
      lineJoin: 'round',
      lineCap: 'round',
      showDir: true,
      zIndex: 100,
    })
    polyline.setMap(map.value)
    routePolylines.push(polyline)
  })
}

// 加载站点和路线数据
const loadMapData = async () => {
  try {
    const res = await getStopList()
    if (res.code === 200 && res.data) {
      drawStops(res.data)
    }
  } catch (error) {
    console.error('获取站点列表失败:', error)
  }

  try {
    const res = await getRoutePathList()
    if (res.code === 200 && res.data) {
      drawRoutes(res.data)
    }
  } catch (error) {
    console.error('获取路线列表失败:', error)
  }

  // 自适应视野展示所有站点和路线
  fitMapView()
}

// 地图视野自适应，覆盖所有站点和路线
const fitMapView = () => {
  if (!map.value || !AMap) return
  const overlays = [...stopMarkers, ...routePolylines]
  if (overlays.length > 0) {
    // 先自适应聚焦所有点位，再放大两个层级，避免比例过小
    map.value.setFitView(overlays, true, [80, 80, 80, 80])
    const curZoom = map.value.getZoom()
    if (typeof curZoom === 'number') {
      map.value.setZoom(Math.min(curZoom + 3, map.value.getMaxZoom ? map.value.getMaxZoom() : 20))
    }
  }
}

// 加载高德地图 SDK（带 reset 重试，规避永久 failed 状态）
const loadAMapSDK = async () => {
  const opts = {
    key: '6588d9e5b6ae0751c799cb4c7b3e30be',
    version: '2.0',
    plugins: ['AMap.ControlBar'],
  }
  if (typeof AMapLoader.reset === 'function') {
    AMapLoader.reset()
  }
  return await AMapLoader.load(opts)
}

// 初始化地图（样式参考 dashboard/matedata.vue）
const initMap = async () => {
  try {
    await nextTick()

    AMap = await loadAMapSDK().catch((error) => {
      throw new Error(`高德地图API加载失败: ${error.message || error}`)
    })

    map.value = new AMap.Map('home-map-container', {
      zoom: 6,
      mapStyle: 'amap://styles/darkblue', // 科技感深蓝色地图样式
      center: [103.8349, 36.058], // 甘肃省中心点
      viewMode: '3D',
      pitch: 50,
      rotation: 0,
      skyColor: '#001a33',
      fog: {
        color: 'rgba(0, 26, 51, 0.8)',
        near: 5000,
        far: 10000,
      },
    })

    map.value.setZooms([2, 20])

    // 启用3D地图交互控制
    map.value.plugin(['AMap.ControlBar'], () => {
      const controlBar = new AMap.ControlBar({
        position: 'RB',
        showZoomBar: true,
        showControlButton: true,
        autoPosition: true,
      })
      map.value.add(controlBar)
    })

    const handleResize = () => {
      if (map.value) {
        try {
          map.value.resize()
        } catch (e) {
          /* ignore */
        }
      }
      if (deptVehicleChartInstance) {
        try {
          deptVehicleChartInstance.resize()
        } catch (e) {
          /* ignore */
        }
      }
      if (approvalChartInstance) {
        try {
          approvalChartInstance.resize()
        } catch (e) {
          /* ignore */
        }
      }
      if (mileageChartInstance) {
        try {
          mileageChartInstance.resize()
        } catch (e) {
          /* ignore */
        }
      }
    }
    window.addEventListener('resize', handleResize)

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })
  } catch (error) {
    console.error('地图初始化失败:', error)
  }
}

onMounted(async () => {
  await initMap()
  await loadMapData()
  await loadCompanyList()
  await loadVehicleTotalCount()
  await fetchVehicleOnlineCount()
  await loadDeptVehicleData()
  await loadApprovalData()
  await loadAlarmLevelCount()
  await loadCompanyAlarmLevelInfo()
  // 初始化路权审批饼图（接口数据加载后渲染）
  nextTick(() => initApprovalChart())
  // 初始化近7天运行里程柱状图（模拟数据）
  nextTick(() => initMileageChart())
  // 检测企业名称是否溢出，溢出时启用跑马灯
  nextTick(() => checkMarqueeOverflow())
  startOnlineStatusRefresh()
})

// 检测企业名称文字是否超出列宽，仅在溢出时启用跑马灯动画
const checkMarqueeOverflow = () => {
  nextTick(() => {
    const elList = document.querySelectorAll('.marquee-text')
    elList.forEach((el) => {
      const span = el
      const wrap = span.parentElement
      if (!wrap) return
      // 文字宽度 > 容器宽度时启用滚动动画
      if (span.scrollWidth > wrap.clientWidth) {
        span.classList.add('marquee-active')
      } else {
        span.classList.remove('marquee-active')
      }
    })
  })
}

// 企业列表/告警列表变化时重新检测跑马灯（轮播切换、数据刷新）
watch(displayCompanyList, () => checkMarqueeOverflow())
watch(companyAlarmList, () => checkMarqueeOverflow(), { deep: true })

onBeforeUnmount(() => {
  stopPolling()
  stopOnlineStatusRefresh()
  if (deptVehicleChartInstance) {
    deptVehicleChartInstance.dispose()
    deptVehicleChartInstance = null
  }
  if (approvalChartInstance) {
    approvalChartInstance.dispose()
    approvalChartInstance = null
  }
  if (mileageChartInstance) {
    mileageChartInstance.dispose()
    mileageChartInstance = null
  }
  if (map.value) {
    map.value.destroy()
    map.value = null
  }
})
</script>

<style scoped lang="less">
.home-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
}

// 地图层 - 最底层
.map-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

#home-map-container {
  width: 100%;
  height: 100%;
}

// 内容层 - 地图上层
.content-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}

// 左侧面板区
.left-panel-area {
  position: absolute;
  left: 20px;
  top: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  pointer-events: auto;
  width: 360px;
}

// 右侧面板区
.right-panel-area {
  position: absolute;
  right: 20px;
  top: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  pointer-events: auto;
  width: 360px;
}

// 信息面板（参考 matedata.vue 的 dashboard-card 样式）
.info-panel {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(92, 172, 238, 0.5);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1),
  0 0 10px rgba(92, 172, 238, 0.3);
  padding: 16px;
  min-height: 120px;
  flex-shrink: 0;
}

.panel-header {
  margin-bottom: 8px;
  padding-bottom: 8px;
  position: relative;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 0 3px rgba(92, 172, 238, 0.3);
  display: inline-block;
}

// 标题下方装饰线条
.panel-header::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 30%;
  height: 3px;
  background-color: #5cacee;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(92, 172, 238, 0.5);
  z-index: 2;
}

.panel-header::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: rgba(92, 172, 238, 0.8);
  border-radius: 1px;
  z-index: 1;
}

.panel-body {
  min-height: 80px;
}

// 企业车辆统计饼图容器
.dept-chart-container {
  width: 100%;
  height: 180px;
}

// 路权审批指标饼图容器
.approval-chart-container {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  gap: 16px;
}

// 运行里程信息样式
.mileage-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.mileage-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 8px;
  background-color: rgba(92, 172, 238, 0.2);
  border-radius: 8px;

  &.today {
    background-color: rgba(0, 188, 212, 0.2);
  }
}

.mileage-label {
  font-size: 13px;
  color: #fff;
  font-weight: 500;
  white-space: nowrap;
}

.mileage-number {
  font-size: 24px;
  font-weight: bold;
  color: #5cacee;
  text-shadow: 0 0 8px rgba(92, 172, 238, 0.8), 0 0 15px rgba(92, 172, 238, 0.5);

  .today & {
    color: #00bcd4;
    text-shadow: 0 0 8px rgba(0, 188, 212, 0.8), 0 0 15px rgba(0, 188, 212, 0.5);
  }
}

.mileage-unit {
  font-size: 13px;
  font-weight: normal;
  color: #fff;
  text-shadow: none;
  margin-left: 4px;
  vertical-align: middle;
}

// 近7天运行里程柱状图容器
.mileage-chart-container {
  width: 100%;
  height: 150px;
}

// 事件概括样式（参考 matedata.vue）
.event-summary {
  padding: 4px 0;
}

.event-circles {
  display: flex;
  justify-content: space-around;
  margin-bottom: 14px;
}

.event-circle {
  text-align: center;
}

.circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
  background: transparent;
  border: 2px solid;
}

.circle.blue {
  border-color: #1976d2;
  color: #1976d2;
  text-shadow: 0 0 6px rgba(25, 118, 210, 0.6);
}

.circle.yellow {
  border-color: #ffb300;
  color: #ffb300;
  text-shadow: 0 0 6px rgba(255, 179, 0, 0.6);
}

.circle.orange {
  border-color: #ff9800;
  color: #ff9800;
  text-shadow: 0 0 6px rgba(255, 152, 0, 0.6);
}

.circle.red {
  border-color: #f44336;
  color: #f44336;
  text-shadow: 0 0 6px rgba(244, 67, 54, 0.6);
}

.circle-label {
  font-size: 11px;
  color: #fff;
}

.event-circle:nth-child(1) .circle-label { color: #1976d2; }
.event-circle:nth-child(2) .circle-label { color: #ffb300; }
.event-circle:nth-child(3) .circle-label { color: #ff9800; }
.event-circle:nth-child(4) .circle-label { color: #f44336; }

.event-table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 6px;
}

.event-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  color: #fff;
  table-layout: fixed;

  th {
    background: rgba(0, 188, 212, 0.2);
    border-top: 1px solid rgba(0, 188, 212, 0.3);
    border-bottom: 1px solid rgba(0, 188, 212, 0.3);
    padding: 6px;
    text-align: center;
    font-weight: bold;
    color: #00bcd4;
    text-shadow: 0 0 3px rgba(0, 188, 212, 0.3);
    white-space: nowrap;
  }

  td {
    border-bottom: 1px solid rgba(0, 188, 212, 0.2);
    padding: 6px;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    overflow: hidden;
  }

  // 企业列固定宽度
  .col-company {
    width: 100px;
  }

  tr:hover td {
    background: rgba(0, 188, 212, 0.1);
  }
}

// 左侧饼图
.approval-pie {
  flex: 0 0 38%;
  height: 100%;
}

// 右侧审核项列表（三行垂直排列）
.approval-legend {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// 每项带外边框（单行不换行，固定高度防变形）
.approval-item {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  padding: 8px 10px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.2);
  overflow: hidden;

  // 颜色圆点
  .approval-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .approval-name {
    color: #fff;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
  }

  .approval-value {
    color: #5cacee;
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
  }

  // 百分比
  .approval-percent {
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    margin-left: auto;
  }

  // 三种状态颜色
  &.pass .approval-dot { background: #4caf50; box-shadow: 0 0 6px rgba(76, 175, 80, 0.6); }
  &.pass .approval-percent { color: #4caf50; }
  &.pending .approval-dot { background: #ff9800; box-shadow: 0 0 6px rgba(255, 152, 0, 0.6); }
  &.pending .approval-percent { color: #ff9800; }
  &.reject .approval-dot { background: #f44336; box-shadow: 0 0 6px rgba(244, 67, 54, 0.6); }
  &.reject .approval-percent { color: #f44336; }
}

// 车辆状况样式（参考 matedata.vue）
.vehicle-status-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 12px;

  &.operation-metrics {
    margin-top: 12px;
  }
}

.vehicle-total, .vehicle-online {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 4px;
  background-color: rgba(92, 172, 238, 0.2);
  border-radius: 8px;
  padding: 12px 8px;
}

.vehicle-label {
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 500;
}

.vehicle-number {
  font-size: 28px;
  font-weight: bold;
  color: #5CACEE;
  text-shadow: 0 0 8px rgba(92, 172, 238, 0.8),
  0 0 15px rgba(92, 172, 238, 0.5);
}

.vehicle-number.online {
  color: #00FF00;
  text-shadow: 0 0 8px rgba(0, 255, 0, 0.5),
  0 0 15px rgba(0, 255, 0, 0.3);
}

.vehicle-unit {
  font-size: 14px;
  font-weight: normal;
  color: #FFFFFF;
  text-shadow: none;
  margin-left: 4px;
  vertical-align: middle;
}

// 企业概括表格样式（参考 matedata.vue）
.enterprise-table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;
}

.enterprise-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #fff;
  table-layout: fixed;

  th {
    background: rgba(0, 188, 212, 0.2);
    border-top: 1px solid rgba(0, 188, 212, 0.3);
    border-bottom: 1px solid rgba(0, 188, 212, 0.3);
    padding: 8px;
    text-align: left;
    font-weight: bold;
    color: #00bcd4;
    text-shadow: 0 0 3px rgba(0, 188, 212, 0.3);
    white-space: nowrap;
  }

  td {
    border-bottom: 1px solid rgba(0, 188, 212, 0.2);
    padding: 8px;
    background: rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }

  // 序号列固定窄宽度
  .col-index {
    width: 30px;
  }

  // 企业名称列固定宽度
  .col-company {
    width: 120px;
  }

  tr:hover td {
    background: rgba(0, 188, 212, 0.1);
    box-shadow: inset 0 0 10px rgba(0, 188, 212, 0.1);
  }

  .text-right {
    text-align: right;
  }

  .empty-tip {
    text-align: center;
    color: #999;
    padding: 20px;
  }
}

// 跑马灯文字滚动（企业名称超出列宽时轮播显示）
.marquee-wrap {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.marquee-text {
  display: inline-block;
  white-space: nowrap;
}

// 仅在文字溢出时（添加 marquee-active 类）启用滚动动画
.marquee-text.marquee-active {
  animation: marquee-scroll 8s linear infinite;
}

// 鼠标悬停暂停滚动
.marquee-wrap:hover .marquee-text.marquee-active {
  animation-play-state: paused;
}

@keyframes marquee-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
}
</style>
